import Seo from "../components/Seo";
import Section from "../components/ui-custom/Section";
import ContactForm from "../components/sections/ContactForm";
import PageHeader from "../components/ui-custom/PageHeader";
import { useData } from "../hooks/useData";

export default function Contact() {
  const { data } = useData("contact");
  return (
    <>
      <Seo title="Contact" description="Get in touch with the utipanagecy team. Email, phone, WhatsApp and Telegram." />
      <PageHeader eyebrow="Contact" title={data?.heading || "Let's build your digital counter"} sub={data?.subheading} />
      <Section testId="contact-page">
        <ContactForm />
      </Section>
    </>
  );
}
